import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Entity } from '../../../../../types/utility';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { patchApplicationBroker } from '../../requests/patchApplicationBroker';

export const useUpdateApplicationBroker = (definitionName: string) => {
  const queryClient = useQueryClient();
  const { constructPatch } = useRequestConstructor();

  const { mutateAsync: updateBroker, ...rest } = useMutation({
    mutationFn: ({ uuid, data }: { uuid: string; data: Entity }) =>
      patchApplicationBroker(constructPatch, uuid, definitionName, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['brokers'] });
    },
  });

  return { updateBroker, ...rest };
};
